import { CarouselEffect } from '~/common/enums/enums';
import { EffectCoverflow } from 'swiper/modules';

const carouselEffectToModule = {
  [CarouselEffect.COVERFLOW]: EffectCoverflow,
};

export { carouselEffectToModule };
